module.exports = __webpack_public_path__ + "static/media/test7_2.d12dd121.png";